<div *ngIf="formType != 'FormC'" class="usan-form-item suggested-names-container" cdkDropList (cdkDropListDropped)="drop($event)">
  <span class="suggested-name-text">You may submit up to {{maxSuggestedNames}} Suggested Name(s) in Order of Preference.</span>
  <div class="drop-list" *ngFor="let name of suggestedNames; track name; let i = index">
    <div class="suggested-name-item-line" id="{{ 'suggested-name-edit-' + i }}">
      <mat-form-field appearance="outline" class="suggested-name-form-field">
        <mat-label>{{ formFieldTitle }}</mat-label>
        <input matInput #suggestedNamesInput [ngModel]="getSuggestedName(i)" class="suggested-name suggested-name-item-input"
          (keyup.enter)="updateSuggestedName(i, $event)" (keyup.escape)="cancelEdit(i)" (blur)="updateSuggestedName(i, $event)" />
        <mat-icon matSuffix (click)="clearSuggestedNameOnEdit(i)">cancel</mat-icon>
      </mat-form-field>
    </div>
  </div>
  <div class="suggested-name-item-container" *ngIf="canAddSuggestedName()">
    <div class="suggested-name-item-input-container">
      <mat-form-field appearance="outline" class="suggested-name-form-field">
        <mat-label>{{ formFieldTitle }}</mat-label>
        <input matInput #suggestedNamesInput [(ngModel)]="nameToAdd" class="suggested-name suggested-name-item-input"
          (keyup.enter)="addSuggestedName($event)" (blur)="addSuggestedName($event)"  />
        <mat-icon matSuffix (mousedown)="removeSuggestedName()" (keydown)="removeSuggestedName()">cancel</mat-icon>
      </mat-form-field>
    </div>
  </div>
  <div class="suggested-name-form-info suggested-name-form-info-text">
      Please be prepared to attach verification of the absence of conflicts with existing chemical names, insecticides, other nonproprietary names or trademarks in the upload documents section.
    </div>
  <div class="input-error" *ngIf="hasFieldValidationError('suggestedNamesFormA')">
    This is a required field.
  </div>
</div>
<div *ngIf="formType === 'FormC'" class="usan-form-item suggested-names-container"> <!-- cdkDropList (cdkDropListDropped)="drop($event)"-->
  <span class="suggested-name-text">Only 1 Suggested Name allowed.</span>
  <div class="suggested-name-item-container">
    <div class="suggested-name-item-input-container">
      <mat-form-field appearance="outline" class="suggested-name-form-field">
        <mat-label>{{ formFieldTitle }}</mat-label>
        <input matInput #suggestedNamesInput [(ngModel)]="suggestedSingleName" class="suggested-name suggested-name-item-input"
          (keyup.enter)="addSuggestedName($event)" (blur)="addSuggestedName($event)"  />
        <mat-icon matSuffix (mousedown)="removeSuggestedName()" (keydown)="removeSuggestedName()">cancel</mat-icon>
      </mat-form-field>
    </div>
  </div>
  <div class="suggested-name-form-info suggested-name-form-info-text">
    Documentation of a trademark/linguistics search is not required if the name is derived from an existing USAN.
  </div>
  <div class="input-error" *ngIf="hasFieldValidationError('suggestedNamesFormA')">
    This is a required field.
  </div>
</div>